import Vue from 'vue';
import VueRouter from 'vue-router';
import { getAuth } from "../firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../components/Dashboard.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('../components/Usuario/Perfil.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () => import('../components/Clientes/Plataform.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/nueva-orden-de-trabajo',
    name: 'nueva-orden-de-trabajo',
    component: () => import('../components/Trabajos/Orden de trabajo/OrdenDeTrabajo.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/ordenes-de-trabajo',
    name: 'ordenes-de-trabajo',
    component: () => import('../components/Trabajos/programacion de orden de trabajo/ListadoOrdenes.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/ver-ordenes',
    name: 'repro-ordenes-de-trabajo',
    component: () => import('../components/Trabajos/programacion de orden de trabajo/reListadoOrdenes.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/programar-orden',
    name: 'programar-orden',
    component: () => import('../components/Trabajos/programacion de orden de trabajo/OrderBy.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/lista-equipos',
    name: 'lista-equipos',
    component: () => import('../components/Equipos/equipo.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/nuevo-equipo',
    name: 'nuevo-equipo',
    component: () => import('../components/Equipos/nuevo.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/equipo',
    name: 'nuevo-equipo',
    component: () => import('../components/Equipos/View.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/editar-equipo',
    name: 'editar-equipo',
    component: () => import('../components/Equipos/editar-equipo.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/solicitantes',
    name: 'solicitantes',
    component: () => import('../components/Clientes/solicitantes.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/toma-de-horas',
    name: 'toma',
    component: () => import('../components/Trabajos/TomaHoras.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/reporte/toma-de-horas',
    name: 'toma',
    component: () => import('../components/Trabajos/HistorialTomaHoras.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/trabajos-finalizados',
    name: 'trabajos-finalizados',
    component: () => import('../components/Trabajos/HistorialFinalizados.vue'),
  },
  {
    path: '/emitir-reporte',
    name: 'emitir-reporte',
    component: () => import('../components/Trabajos/ReporteFinal.vue'),
  }
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requireAuth);
  const user = getAuth().currentUser;

  if (requiresAuth && !user) {
    next({ name: 'home' });  // Redirigir a la página de login si el usuario no está autenticado
  } else {
    next();
  }
});

export default router;
